import { render, staticRenderFns } from "./cardGraficoDosisVacunas.vue?vue&type=template&id=9757be7a&"
import script from "./cardGraficoDosisVacunas.vue?vue&type=script&lang=js&"
export * from "./cardGraficoDosisVacunas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports